/*
 * @Author: 张玉婷
 * @Date: 2022-03-16 15:41:36
 * @LastEditTime: 2022-03-16 16:00:31
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\coordinateConversions\index.ts
 */
export default class CoorsOffset {
  // eslint-disable-next-line camelcase
  x_pi: any;

  pi: any;

  a: any;

  ee: any;

  constructor () {
    this.x_pi = (3.14159265358979324 * 3000.0) / 180.0;
    this.pi = 3.14159265358979324;
    this.a = 6378245.0;
    this.ee = 0.00669342162296594323;
  }

  /**
   * WGS84转GCj02
   * @param {any} lng 经度
   * @param {any} lat 经度
   * @returns {any} 转换后的坐标
   */
  wgs84togcj02 = (lng: number, lat: number): any => {
    const radlat = (lat / 180.0) * this.pi;
    const magic = 1 - this.ee * Math.sin(radlat) * Math.sin(radlat);
    const sqrtmagic = Math.sqrt(magic);

    let dlat = this.transformlat(lng - 105.0, lat - 35.0);

    let dlng = this.transformlng(lng - 105.0, lat - 35.0);

    dlat = (dlat * 180.0) / (((this.a * (1 - this.ee)) / (magic * sqrtmagic)) * this.pi);
    dlng = (dlng * 180.0) / ((this.a / sqrtmagic) * Math.cos(radlat) * this.pi);
    const mglat = lat + dlat;

    const mglng = lng + dlng;

    return [mglng, mglat,];
  }

  /**
   * GCJ02 转换为 WGS84
   * @param {any} lng 经度
   * @param {any} lat 经度
   * @returns {any} 转换后的坐标
   */
  gcj02towgs84 = (lng: any, lat: any): any => {
    let dlat = this.transformlat(lng - 105.0, lat - 35.0);
    let dlng = this.transformlng(lng - 105.0, lat - 35.0);
    const radlat = (lat / 180.0) * this.pi;
    const magic = 1 - this.ee * Math.sin(radlat) * Math.sin(radlat);
    const sqrtmagic = Math.sqrt(magic);

    dlat = (dlat * 180.0) / (((this.a * (1 - this.ee)) / (magic * sqrtmagic)) * this.pi);
    dlng = (dlng * 180.0) / ((this.a / sqrtmagic) * Math.cos(radlat) * this.pi);

    const mglat = lat + dlat;
    const mglng = lng + dlng;

    return [lng * 2 - mglng, lat * 2 - mglat,];
  }

  transformlat = (lng: any, lat: any) => {
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));

    ret += (20.0 * Math.sin(6.0 * lng * this.pi) + 20.0 * Math.sin(2.0 * lng * this.pi)) * (2.0 / 3.0);
    ret += (20.0 * Math.sin(lat * this.pi) + 40.0 * Math.sin((lat / 3.0) * this.pi)) * (2.0 / 3.0);
    ret += (160.0 * Math.sin((lat / 12.0) * this.pi) + 320 * Math.sin((lat * this.pi) / 30.0)) * (2.0 / 3.0);

    return ret;
  }

  transformlng = (lng: any, lat: any) => {
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));

    ret += (20.0 * Math.sin(6.0 * lng * this.pi) + 20.0 * Math.sin(2.0 * lng * this.pi)) * (2.0 / 3.0);
    ret += (20.0 * Math.sin(lng * this.pi) + 40.0 * Math.sin((lng / 3.0) * this.pi)) * (2.0 / 3.0);
    ret += (150.0 * Math.sin((lng / 12.0) * this.pi) + 300.0 * Math.sin((lng / 30.0) * this.pi)) * (2.0 / 3.0);

    return ret;
  }
}
